import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lists"]

  addList() {
    const html = `
      <div class="flex items-center gap-2" data-template-form-target="listItem">
        <span class="w-2 h-2 rounded-full flex-shrink-0 bg-slate-400"></span>
        <input type="text" 
               name="template[structure][lists][][name]" 
               value=""
               placeholder="List name"
               class="flex-1 text-sm text-slate-700 dark:text-slate-300 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg py-1.5 px-3 focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50">
        <input type="hidden" name="template[structure][lists][][type]" value="default">
        <button type="button"
                data-action="click->template-form#removeList"
                class="p-1 rounded text-slate-400 hover:text-red-500 dark:hover:text-red-400 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
    `
    this.listsTarget.insertAdjacentHTML("beforeend", html)
  }

  removeList(event) {
    event.currentTarget.closest("[data-template-form-target='listItem']").remove()
  }
}